<template>
  <v-card class="rsl-fixed-height">
    <v-container>
      <v-row>
        <v-col md="12">
          <v-card class="pa-5">
            <v-card-title>
              {{ $t('SUPPORT.TITLE') }}
            </v-card-title>
            <v-form v-model="isFormValid" ref="supportForm">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="supportFrom"
                    :type="'text'"
                    :label="$t('SUPPORT.FIELDS.FROM')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="supportTo"
                    :type="'text'"
                    :label="$t('SUPPORT.FIELDS.TO')"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="supportSubject"
                    :type="'text'"
                    :label="$t('SUPPORT.FIELDS.SUBJECT')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    solo
                    v-model="supportCategory"
                    :items="categories"
                    item-text="name"
                    item-value="val"
                    :label="$t('SUPPORT.FIELDS.CATEGORY')"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    :label="$t('SUPPORT.FIELDS.DESC')"
                    v-model="supportDescription"
                    :rules="[rules.required]"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-file-input
                    :show-size="1024"
                    :label="$t('SUPPORT.FIELDS.FILES')"
                    v-model="attachments"
                  ></v-file-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    right
                    class="mr-2 float-right"
                    color="success"
                    @click="submitRequest()"
                    :disabled="!isFormValid"
                  >{{ $t('SUPPORT.BTNS.SUBMIT') }}</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="supportResultDialog"
        :retain-focus="false"
        persistent
      >
        <template>
          <v-card>
            <v-toolbar
              color="#f87723"
              dark
            >{{ supportResultTitle }}</v-toolbar>
            <v-card-text>
              <div class="pt-5">{{ supportResultText }}</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                @click="close()"
              >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>

    <v-snackbar
      v-model="snack"
      :timeout="snackTimeout"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

  </v-card>
</template>

<script>

import { mapGetters } from 'vuex';
export default {
  name: 'support',
  computed: {
    ...mapGetters(['supportRequest', 'supportEmail'])
  },
  data: function() {
    return {
      isFormValid: false,
      currentRole: this.$store.state.currentRole,
      supportFrom: this.$store.state.currentUserFullname + ' (' + this.$store.state.currentUserEmail + ')',
      supportTo: '',
      supportSubject: '',
      supportCategory: null,
      supportDescription: '',
      attachments: null,
      supportResultDialog: false,
      supportResultTitle: '',
      supportResultText: '',
      categories: [
        { name: this.$t('SUPPORT.CATEGORIES.DB_TABLES'), val: 'Database Tables' },
        { name: this.$t('SUPPORT.CATEGORIES.FORMS'), val: 'Forms' },
        { name: this.$t('SUPPORT.CATEGORIES.PROCESSES'), val: 'Processes' },
        { name: this.$t('SUPPORT.CATEGORIES.REPORTING'), val: 'Reporting' },
        { name: this.$t('SUPPORT.CATEGORIES.TEMPLATES'), val: 'Templates' },
        { name: this.$t('SUPPORT.CATEGORIES.OTHER'), val: 'Other' }
      ],
      rules: {
        required: value => !!value || 'Required'
      },
      snack: false,
      snackColor: '',
      snackText: '',
      snackTimeout: 3000
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {

      if(mutation.type === 'SUPPORT_EMAIL') {
        this.supportTo = this.supportEmail;
      }

      if(mutation.type === 'SUPPORT_REQUEST') {
        if(this.supportRequest) {
          this.supportResultTitle = this.$t('SUPPORT.RESULT_TITLE_SUCCESS');
          this.supportResultText = this.$t('SUPPORT.RESULT_TEXT_SUCCESS');
          this.supportResultDialog = true;
        }else {
          this.supportResultTitle = this.$t('SUPPORT.RESULT_TITLE_FAIL');
          this.supportResultText = this.$t('SUPPORT.RESULT_TEXT_FAIL');
          this.supportResultDialog = true;
        }
      }

    });

    if(this.currentRole == 'adminRole') {
      this.supportTo = 'demo@rabbitsoftware.ltd';
    }else {
      let supportPayload = { 'action': 'get' };
      this.$store.dispatch('supportSettings', supportPayload);
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  methods: {
    encodeImgtoBase64(file, callback) {
      var reader = new FileReader();
      reader.onloadend = callback;
      reader.readAsDataURL(file);
    },
    submitRequest() {
      let fileName = '';
      let mimeType = '';
      let fileSize = 0;
      let fileData = '';
      let from = this.$store.state.currentUserFullname;
      let to = this.supportTo;
      let ref = this;

      let body = '<p>From: ' + this.supportFrom + '</p>';
      body += '<p>Subject: ' + this.supportSubject + '<p>';
      body += '<p>Category: ' + this.supportCategory + '<p>';
      body += '<p>Description: ' + this.supportDescription + '<p>';
      
      if(this.attachments) {
        fileName = this.attachments.name;
        mimeType = this.attachments.type;
        fileSize = this.attachments.size;

        // Check file size
        let size = ((fileSize/1024)/1024).toFixed(4); // MB
        let sizeError = false;
        if(size > 60) {
          sizeError = true;
        }

        if(!sizeError) {
          this.encodeImgtoBase64(this.attachments, function(base64) {
            // Strip out the base64 test at the start
            let index = base64.target.result.indexOf('base64');
            index += 7;
            fileData = base64.target.result.slice(index);

            let payload = {
              'from': from,
              'to': to,
              'body': body,
              'fileData': fileData,
              'fileName': fileName,
              'mimeType': mimeType
            }

            ref.sendRequest(payload);
          });
        }else {
          this.snackFileTooBig();
        }
      }else {
        let payload = {
          'from': from,
          'to': to,
          'body': body
        }

        this.sendRequest(payload);
      }
    },
    sendRequest(payload) {
      this.$store.dispatch('sendSupportRequest', payload);
    },
    close() {
      this.supportResultDialog = false;
      if(this.supportRequest) {
        this.$refs.supportForm.reset();
        this.$router.push({ name: 'Home' });
      }
    },
    snackFileTooBig() {
      this.snack = true;
      this.snackTimeout = 10000;
      this.snackColor = 'error';
      this.snackText = 'The attached file is larger than 60MB. Please attach a smaller file.';
    }
  }
}
</script>